import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'
import Lang from '../components/language/services/Lang';

/* ------------- Types and Action Creators ------------- */
const { Types, Creators } = createActions({
    resetLayout: null,
    setLanguage: ['userAccountId', 'lang'],
    setPageLanguage: ['userAccountId','lang'],
    setSelectedButton: ['selectedButton'],
    setPageLoading: ['isLoading']
})

export const LayoutTypes = Types
export default Creators

/* ------------- Initial State ------------- */
export const INITIAL_STATE = Immutable({
    lang: localStorage.getItem('lang_id') ? localStorage.getItem('lang_id') : 'en',
    selectedButton: 'Dashboard',
    isPageLoading: false
})

/* ------------- Reducers ------------- */
export const layoutResetLayout = (state) => INITIAL_STATE

export const layoutSetLanguage = (state, { userAccountId, lang }) => {
    const language = lang === "fr" ? "fr" : "en"
    localStorage.setItem('lang_id', language)
    Lang.setCurrentLanguage(language)
    return state.merge({ lang: language })
}

export const layoutSetSelectedButton = (state, { selectedButton }) => {
    if (selectedButton === 'Dashboard') {
        return state.merge({ selectedButton: 'Dashboard' })
    }
    else if (selectedButton === 'ClientLookup') {
        return state.merge({ selectedButton: 'ClientLookup' })
    }
    else if (selectedButton === 'Home') {
        return state.merge({ selectedButton: 'Home' })
    }
    else {
        return state.merge({ selectedButton: 'BlockSignal' })
    }
}

export const layoutSetPageLoading = (state, { isLoading }) =>
    state.merge({ isPageLoading: isLoading })

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
    [Types.RESET_LAYOUT]: layoutResetLayout,
    [Types.SET_LANGUAGE]: layoutSetLanguage,
    [Types.SET_PAGE_LANGUAGE]: layoutSetLanguage,
    [Types.SET_SELECTED_BUTTON]: layoutSetSelectedButton,
    [Types.SET_PAGE_LOADING]: layoutSetPageLoading
})